// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  workInfoWorkTypeQuery: ({commit, state}, params) => request.alert('workInfoWorkTypeQuery', params),
  workInfoWorkTypeCreate: ({commit, state}, params) => request.alert('workInfoWorkTypeCreate', params),
  workInfoWorkTypeEdit: ({commit, state}, params) => request.alert('workInfoWorkTypeEdit', params),
  workInfoWorkTypeGet: ({commit, state}, params) => request.alert('workInfoWorkTypeGet', params),
  workInfoWorkTypeDelete: ({commit, state}, params) => request.alert('workInfoWorkTypeDelete', params),
  workInfoWorkTypeChangeStatus: ({commit, state}, params) => request.alert('workInfoWorkTypeChangeStatus', params),
}

// mutations
const mutations = {}

export const workInfoWorkType = {
  state,
  getters,
  actions,
  mutations,
}




// WEBPACK FOOTER //
// ./src/views/work-info-work-type/work-info-work-type.store.js